var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length
    ? _c(
        "div",
        {
          staticClass: "navigation-left",
          attrs: { role: "navigation", "aria-label": "Left navigation" },
        },
        [
          _c(
            "div",
            { staticClass: "navigation-left__list" },
            _vm._l(_vm.data, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "navigation-left__item-wrapper" },
                [
                  _c("a", {
                    staticClass: "navigation-left__item",
                    class: { "is-active": item.active },
                    attrs: {
                      href: item.link,
                      title: item.name,
                      target: item.params.BLANK ? "_blank" : false,
                    },
                    domProps: { innerHTML: _vm._s(item.name) },
                  }),
                  _vm._v(" "),
                  item.items
                    ? _vm._l(item.items, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "navigation-left__item-wrapper",
                          },
                          [
                            _c("a", {
                              staticClass: "navigation-left__item",
                              class: { "is-active": item.active },
                              attrs: {
                                href: item.link,
                                target: item.params.BLANK ? "_blank" : false,
                                title: item.name,
                              },
                              domProps: { innerHTML: _vm._s(item.name) },
                            }),
                          ]
                        )
                      })
                    : _vm._e(),
                ],
                2
              )
            }),
            0
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }